import { arrayUnion, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveFormRecord from "../../../Components/CluppForms/saveFormRecord";
import Swal from "sweetalert2";
import ProcedureQuestion from "./ProcedureQuestion";

const landingId = "CF_PROCEDURE_QUESTION";

const onLoad = async ({ session, landedAt, uid, fieldsStructure }) => {
  const prevAnswers = {};
  const cancelationReasons = [];
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  const itemsFromThisLanding = prevForm.items.find(
    (items) => items.landingId === landingId
  );
  if (itemsFromThisLanding) {
    const thisField = itemsFromThisLanding?.answers[0];
    const thisFieldType = thisField.type; // choice
    const thisFieldAnswers = thisField[thisFieldType].value;
    cancelationReasons.push(thisFieldAnswers);
  }

  return {
    userId: uid,
    ...prevAnswers,
    [fieldsStructure[0].field.id]: cancelationReasons,
    landedAt,
    prevForm,
    currentLanding: landingId,
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
  setLoading,
}) => {
  if (session?.sessionID) {
    try {
      const path = `IT/forms/cancelation-form/${session.sessionID}`;
      const docRef = doc(db, path);
      const prevForm = await getFormSession(
        "cancelation-form",
        session.sessionID
      );
      const lastField = prevForm.items[1];
      const newLanding = {
        landingId,
        landedAt: state.landedAt,
        submittedAt: Date.now(),
      };
      const fieldID = fieldsStructure[0].field.id;
      const optionSelected = state[fieldID][0];
      let value = optionSelected;
      if (!optionSelected?.id) {
        setLoading(false);
        return Swal.fire({
          icon: "warning",
          text: "Por favor, selecciona una de las opciones.",
          confirmButtonColor: "#00bbee",
        });
      }
      if (optionSelected.id === "Otro") {
        value = optionSelected;
      }
      const field = fieldsStructure[0];
      const fieldType = field.type;

      field[fieldType].value = value;
      const answers = [field];
      newLanding.answers = answers;
      const updateData = lastField
        ? [prevForm.items[0], newLanding]
        : arrayUnion(newLanding);

      await saveFormRecord(session.sessionID, {
        ...prevForm,
        items: updateData,
      });
      await updateDoc(docRef, {
        items: updateData,
        processed: false
      });

      console.log("State successfully written to Firestore!");
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <ProcedureQuestion
    state={state}
    setState={setState}
    field={"CF_procedure_question_jq8t7"}
  /> // Field ID
);

const nextPage = (props) => `/formulario/cancelacion/lealtad?uid=${props.uid}`;

const prevPage = (props) => `/formulario/cancelacion/razon?uid=${props.uid}`;
const fieldsStructure = [
  {
    field: {
      id: "CF_procedure_question_jq8t7",
      type: "multiple_choice",
      ref: "CF_procedure_question",
    },
    metadata: {},
    type: "choice",
    choice: {
      value: "",
    },
  },
];

const procedureQuestionProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default procedureQuestionProps;
